import { ContentLayout } from 'layouts/ContentLayout/ContentLayout';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import PageTitle from 'components/PageTitle';
import { TokenUserPermissions } from 'api/users/schemas/Users';
import Tabs from 'components/Table/Tabs';
import { DisplayForPermission } from 'components/Permission/DisplayForPermission';
import { useMemo } from 'react';
// Survey removed per G360-3817, kept for future surveys
// import Survey from './Survey';

enum TabsEnum {
  'orders' = 0,
  'draft' = 1,
}

const Orders = () => {
  const navigate = useNavigate();
  const breadcrumbs = [
    {
      icon: 'home',
      label: 'Order services',
      onClick: () => navigate('/access-express/v3/order-services/access'),
    },
    {
      label: 'My orders',
    },
  ];

  const { pathname } = useLocation();

  const tabs = useMemo(() => {
    return [
      {
        title: 'Orders',
        onClick: () => navigate('/access-express/v3'),
      },
      {
        title: 'Drafts',
        onClick: () => navigate('draft'),
      },
    ];
  }, [navigate]);

  const activeTab = useMemo(() => {
    if (pathname.includes('/draft')) return TabsEnum.draft;
    return TabsEnum.orders;
  }, [pathname]);

  return (
    <ContentLayout>
      <div className="mb-12 flex justify-between">
        <PageTitle
          className="w-full"
          title="Order history"
          breadcrumbs={breadcrumbs}
        >
          <div className="my-auto flex gap-4">
            <DisplayForPermission
              permission={TokenUserPermissions.ACCESS_EXPRESS_WRITE}
              upgradeTooltip
            >
              <Link
                className="button primary large"
                to="/access-express/v3/order-services/access"
              >
                Order services
              </Link>
            </DisplayForPermission>
          </div>
        </PageTitle>
      </div>
      {/* Survey removed per G360-3817, kept for future surveys */}
      {/* <Survey /> */}
      <Tabs
        variant="medium"
        className="mb-8"
        defaultActiveTab={activeTab}
        tabs={tabs}
        type="default"
      />
      <Outlet />
    </ContentLayout>
  );
};

export default Orders;
